import { createAction } from '@reduxjs/toolkit';
import { ACTION } from './types';

export const setTestimonialIndex = createAction<number>(ACTION.SET_TESTIMONIAL_INDEX);
